(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/animated-backgrounds/fireworks-background.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/animated-backgrounds/fireworks-background.js');
"use strict";

const {
  useRef,
  useEffect
} = React;
const FancyWorld = function (size, canvas) {
  this.size = size;
  this.update = () => {
    this.size = [canvas.width, canvas.height];
  };
};

const createParticle = (position, velocity, color, parentSize) => ({
  position,
  velocity,
  initialVelocity: velocity,
  color,
  seed: Math.random() * 100,
  size: 2 * parentSize,
  lifespan: 0,
  maxLifespan: Math.round(Math.random() * 5000) + 2000,
  exploded: false,
  update(delta) {
    if (this.lifespan < this.maxLifespan) {
      this.position[0] += this.velocity[0] * (delta * 0.03);
      this.position[1] += this.velocity[1] * (delta * 0.03);
      this.velocity[1] += 0.0001 * this.lifespan * delta * 0.03;
      if (this.lifespan > this.maxLifespan / 4) {
        this.size -= delta * 0.001;
      }
      this.lifespan += delta;
    }
  },
  draw(ctx) {
    if (this.lifespan > 0) {
      ctx.shadowBlur = (Math.sin(this.lifespan * 0.01 + this.seed) + 1) * 10; 
      ctx.shadowColor = this.color; 
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.arc(this.position[0], this.position[1], Math.max(this.size, 0), 0, 2 * Math.PI); 
      ctx.fill();
      ctx.shadowBlur = 0;
    }
  }
});
const fireworksObj = world => {
  const position = [Math.random() * world.size[0], world.size[1]];
  const maxDistance = 0.3;
  const minDistance = 0.5;
  const distance = Math.random() * maxDistance + minDistance;
  const adjustedDistance = 1 - distance;
  const explosionPoint = world.size[1] * adjustedDistance;
  return {
    startOffset: Math.round(Math.random() * 7000),
    lifespan: 0,
    adjustedDistance,
    isEndOfLife: false,
    position,
    velocity: [0, -Math.random() * 3 - 1.5],
    color: "hsl(".concat(Math.random() * 360, ", 100%, 50%)"),
    exploded: false,
    particles: [],
    explosionPoint,
    slowdownPoint: explosionPoint / 2,
    update(obj, world, time, delta) {
      this.lifespan += delta;
      if (this.lifespan < this.startOffset) {
        return;
      }
      if (!this.exploded) {
        this.position[0] += this.velocity[0] * (delta * 0.3);
        this.position[1] += this.velocity[1] * (delta * 0.3);
        if (this.position[1] <= this.explosionPoint) {
          this.exploded = true;
          const count = Math.round(Math.random() * 100) + 50;
          const randomColor = Math.random() > 0.9;
          for (let i = 0; i < count; i++) {
            const angle = Math.random() * Math.PI * 2;
            const speed = Math.random() * 4 + 0.1;
            this.particles.push(createParticle([...this.position], [Math.cos(angle) * speed, Math.sin(angle) * speed], randomColor ? "hsl(".concat(Math.random() * 360, ", 100%, 50%)") : this.color, maxDistance / distance));
          }
        }
      } else {
        this.particles = this.particles.filter(particle => particle.lifespan < particle.maxLifespan);
        if (this.particles.length) {
          this.particles.forEach(particle => particle.update(delta));
        } else {
          this.isEndOfLife = true;
        }
      }
    },
    draw(_, ctx) {
      if (!this.exploded) {
        const trailLength = 50; 
        const headRadius = 3; 

        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.arc(this.position[0], this.position[1], headRadius, 0, 2 * Math.PI);
        ctx.fill();

        for (let i = 0; i < trailLength; i++) {
          const progress = i / trailLength;
          const trailOpacity = 1 - progress; 
          const trailRadius = headRadius * (1 - progress); 

          const trailX = this.position[0] - this.velocity[0] * i * 0.1;
          const trailY = this.position[1] - this.velocity[1] * i * 0.1;

          ctx.fillStyle = "rgba(".concat(this.color.match(/\d+, \d+, \d+/), ",").concat(trailOpacity, ")");
          ctx.beginPath();

          ctx.ellipse(trailX, trailY, trailRadius, trailRadius * (0.5 + Math.random() * 0.5), Math.random() * Math.PI, 0, 2 * Math.PI);
          ctx.fill();
        }
      } else {
        this.particles.forEach(particle => particle.draw(ctx));
      }
    }
  };
};

setGlobal('svs.tickets.play.components.animatedBackgrounds.FireworksBackground', () => {
  const containerRef = useRef();
  const canvasRef = useRef();
  useEffect(() => {
    const world = new FancyWorld([window.innerWidth, window.innerHeight], canvasRef.current);
    const {
      destroy
    } = svs.tickets.play.utils.particleRenderer({
      drawObject: fireworksObj,
      world,
      canvas: canvasRef.current,
      particlePerPixel: 0.00001,
      minParticles: 10
    });
    const onResize = _.debounce(() => {
      if (canvasRef.current) {
        canvasRef.current.height = window.innerHeight;
        canvasRef.current.width = window.innerWidth;
      }
    }, 500);
    addEventListener('resize', onResize);
    return () => {
      removeEventListener('resize', onResize);
      destroy();
    };
  }, []);
  return React.createElement("div", {
    className: "animated-background-container",
    ref: containerRef
  }, React.createElement("canvas", {
    height: window.innerHeight,
    ref: canvasRef,
    width: window.innerWidth
  }));
});

 })(window);